import axios from "axios";
import { appEnv } from "../appEnv";
import { setTokenRequestInterceptor } from "./interceptors";

const apiOcpp = axios.create({
  baseURL: `${appEnv.REACT_APP_API_URL}/proxy-ocpp/api`,
  params: {
    tupi_cache_purge: Date.now(),
  },
});

apiOcpp.interceptors.request.use(setTokenRequestInterceptor);

export default apiOcpp;
